import { focusTrap } from "../focus-trap";
import { onEscape } from "../on-escape";
import { disablePageScroll, enablePageScroll } from "@fluejs/noscroll";

const openMenuTrigger = document.querySelector<HTMLButtonElement>(
    '[data-selector="open-menu-trigger"]',
)!;
const openMenuLabel = openMenuTrigger.getAttribute("data-open-label");
const closeMenuLabel = openMenuTrigger.getAttribute("data-close-label");
const navigationWrapper = document.querySelector<HTMLElement>(
    '[data-selector="main-nav"]',
)!;
const allLinks = navigationWrapper.querySelectorAll("a");
export function initNavigation() {
    openMenuTrigger.addEventListener("click", toggleMenu);
}

function openMenu() {
    navigationWrapper.setAttribute("data-open", "true");
    openMenuTrigger.setAttribute("aria-expanded", "true");
    openMenuTrigger.setAttribute("aria-label", closeMenuLabel!);
    openMenuTrigger.innerHTML = `<svg class="h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path
        d="m6.342 18.41-.707-.707 5.6-5.6-5.6-5.6.707-.708 5.6 5.6 5.6-5.6.708.708-5.6 5.6 5.6 5.6-.708.708-5.6-5.6-5.6 5.6Z"
    />
    </svg>`;
    allLinks.forEach((link) => {
        link.setAttribute("tabindex", "0");
    });

    disablePageScroll();
    focusTrap(navigationWrapper);
    onEscape(
        () => navigationWrapper.getAttribute("data-open") === "true",
        closeMenu,
    );
}

function closeMenu() {
    navigationWrapper.setAttribute("data-open", "false");
    openMenuTrigger.setAttribute("aria-expanded", "false");
    openMenuTrigger.setAttribute("aria-label", openMenuLabel!);
    openMenuTrigger.innerHTML = `<svg class="h-6 w-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3.942 17.372v-1h16v1h-16Zm0-4.769v-1h16v1h-16Zm0-4.77v-1h16v1h-16Z" />
    </svg>`;

    allLinks.forEach((link) => {
        link.setAttribute("tabindex", "-1");
    });

    openMenuTrigger.focus();
    enablePageScroll();
}

function toggleMenu() {
    if (navigationWrapper.getAttribute("data-open") === "true") {
        closeMenu();
    } else {
        openMenu();
    }
}
